<rt-basic-multi-select
  [control]="control()"
  [selectOptions]="options()"
  [preselectedOptions]="preselectedOptions()"
  [isInvalid]="isInvalid()"
  [isReadOnly]="isReadOnly()"
  [disableLocalSearch]="true"
  [hasExtendedPreview]="true"
  (search)="onSearch($event)"
  (scrollChange)="onScrollChange($event)"
/>
